<template>
  <div class="container">
    <v-row class="page-header">
      <v-col class="page-title" cols="12">
        <v-toolbar-title class="font-bold">DB Adapter</v-toolbar-title>
      </v-col>
    </v-row>
    <v-row class="custom-form-control custom-form-control-type-2 custom-figma-1 mb-0">
      <v-col cols="12" class="search-conditions-display">
        <div class="pl-0 pt-0 pb-0 collapse-search-conditions hide">
          <v-btn
            class="btn btn-top"
            color="primary"
            @click.native="displaySearchConditions('collapse')"
          >
            <v-icon x-small class="mr-2">fa fa-chevron-up</v-icon>
            {{ $t('btn.common.collapseConditions') }}
          </v-btn>
        </div>
        <div class="pl-0 pt-0 pb-0 expand-search-conditions">
          <v-btn
            class="btn btn-top"
            color="primary"
            @click.native="displaySearchConditions('expand')"
          >
            <v-icon x-small class="mr-2">fa fa-chevron-down</v-icon>
            {{ $t('btn.common.expandConditions') }}
          </v-btn>
        </div>
      </v-col>
      <v-col cols="12" class="py-0">
        <v-row>
          <v-col
            cols="12"
            lg="9"
            md="9"
            class="comm-header-col data-query-section pb-0 pt-0 mt-0 custom-field-combo custom-figma-1"
          >
            <v-row class="py-0 mt-0 mb-2">
              <v-col cols="12" lg="7" md="7" class="py-0">
                <v-row class="mt-0">
                  <v-col cols="12" lg="3" md="3" class="py-0 mb-0">
                    <v-text-field
                      v-model="db_item.name"
                      :label="$t('lbl.common.conditionSearch.findbyName')"
                      @keyup.enter="searchItem"
                      class="custom-selectbox"
                      dense
                      filled
                      hide-details
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" lg="3" md="3" class="py-0 mb-0">
                    <v-select
                      v-model="db_item.type"
                      :items="types"
                      :menu-props="{ offsetY: true }"
                      :label="$t('lbl.common.conditionSearch.type')"
                      @change="searchItem"
                      dense
                      filled
                      hide-details
                    ></v-select>
                  </v-col>
                  <v-col cols="12" lg="3" md="3" class="py-0 mb-0">
                    <v-select
                      v-model="db_item.company"
                      :items="companySelectList"
                      :menu-props="{ offsetY: true }"
                      :label="$t('lbl.partners.company')"
                      @change="onChangeCompany"
                      dense
                      filled
                      hide-details
                    ></v-select>
                  </v-col>
                  <v-col cols="12" lg="3" md="3" class="py-0 mb-0">
                    <v-select
                      v-model="db_item.agent"
                      :items="agentList"
                      :menu-props="{ offsetY: true }"
                      label="Agent"
                      @change="onChangeAgent"
                      dense
                      filled
                      hide-details
                    ></v-select>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" lg="5" md="5" class="py-0">
                <v-row class="mt-0">
                  <v-col cols="12" lg="4" md="4" class="py-0 mb-0">
                    <v-text-field
                      v-model="db_item.origin"
                      label="Origin"
                      @keyup.enter="searchItem"
                      class="custom-selectbox"
                      dense
                      filled
                      hide-details
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" lg="4" md="4" class="py-0 mb-0">
                    <v-text-field
                      v-model="db_item.target"
                      label="Target"
                      @keyup.enter="searchItem"
                      class="custom-selectbox"
                      dense
                      filled
                      hide-details
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" lg="4" md="4" class="py-0 mb-0">
                    <v-text-field
                      v-model="db_item.module"
                      label="Module"
                      @keyup.enter="searchItem"
                      class="custom-selectbox"
                      dense
                      filled
                      hide-details
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
          <v-col
            class="comm-header-col date-query-section pb-0 pt-0 pr-0 mt-0 text-right custom-figma-1 fixed-float"
            cols="12"
            lg="3"
            md="3"
          >
            <div class="pl-0 py-0 d-inline-flex">
              <v-btn
                class="btn-width-1 btn btn-top btn-search"
                color="primary"
                @click.native="searchItem"
              >
                <v-icon x-small class="mr-2">fa fa-search</v-icon>
                {{ $t('btn.common.search') }}
              </v-btn>
            </div>

            <div class="pl-0 py-0 d-inline-flex">
              <v-menu
                ref="todate_menu"
                v-model="toDate"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="toDateData"
                    :disabled="!dateCond"
                    :class="['date-text', $vuetify.theme.dark ? '' : 'font-semibold']"
                    append-icon="mdi-calendar"
                    dense
                    solo
                    @keypress="formatDate('to', $event)"
                    @change="changeDate('to')"
                    @click:append="on.click"
                  ></v-text-field>
                </template>
                <v-date-picker
                  class="date-period-picker"
                  :allowed-dates="allowedDates"
                  v-model="toDateData"
                  :disabled="!dateCond"
                  @input="
                    toDate = false;
                    changeDate('to');
                  "
                  no-title
                  scrollable
                >
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="todate_menu = false">{{
                    $t('btn.common.cancel')
                  }}</v-btn>
                  <v-btn text color="primary" @click="$refs.todate_menu.save(toDateData)">{{
                    $t('btn.common.ok')
                  }}</v-btn>
                </v-date-picker>
              </v-menu>
            </div>
            <div class="pl-0 py-0 d-inline-flex">
              <v-menu
                ref="fromdate_menu"
                v-model="fromDate"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="fromDateData"
                    :disabled="!dateCond"
                    :class="['date-text', $vuetify.theme.dark ? '' : 'font-semibold']"
                    append-icon="mdi-calendar"
                    dense
                    solo
                    @keypress="formatDate('from', $event)"
                    @change="changeDate('from')"
                    @click:append="on.click"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="fromDateData"
                  :disabled="!dateCond"
                  :max="getMaxDate"
                  @input="
                    fromDate = false;
                    changeDate('from');
                  "
                  class="date-period-picker"
                  no-title
                  scrollable
                >
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="fromdate_menu = false">Cancel</v-btn>
                  <v-btn text color="primary" @click="$refs.fromdate_menu.save(fromDateData)"
                    >OK</v-btn
                  >
                </v-date-picker>
              </v-menu>
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row class="custom-form-control custom-form-control-type-2 custom-figma-1 mb-0">
      <v-col cols="12" class="py-0">
        <v-row>
          <v-col
            cols="12"
            lg="6"
            md="6"
            class="comm-header-col data-query-section pb-0 pt-0 mt-0 custom-field-combo custom-figma-1 mt-2"
          >
            <v-row class="py-0 mt-0 mb-2">
              <v-col cols="12" lg="3" md="3" class="py-0 pr-0">
                <v-select
                  v-model="db_item.dbInstance"
                  :items="dbInstanceList"
                  :label="$t('lbl.dataSource.dbConfig.addDB.dbIns')"
                  :menu-props="{ offsetY: true }"
                  @change="onChangeField"
                  dense
                  filled
                  hide-details
                ></v-select>
              </v-col>
              <v-col cols="12" lg="3" md="3" class="py-0 pr-0">
                <v-autocomplete
                  v-model="db_item.dbIFConfig"
                  :items="dbIFConfigNameSelectList"
                  label="DB I/F Configuration"
                  :menu-props="{ offsetY: true }"
                  @change="onChangeField"
                  dense
                  filled
                  hide-details
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" lg="3" md="3" class="py-0 pr-0">
                <v-select
                  v-model="db_item.controlTable"
                  :items="dbIFControlTableSelectList"
                  label="I/F Control Table"
                  :menu-props="{ offsetY: true }"
                  @change="onChangeField"
                  dense
                  filled
                  hide-details
                ></v-select>
              </v-col>
              <v-col cols="12" lg="3" md="3" class="py-0 pr-0">
                <v-autocomplete
                  v-model="db_item.dbmapper"
                  :items="dbMapperSelectList"
                  :menu-props="{ offsetY: true }"
                  label="DB Mapper"
                  @change="onChangeField"
                  dense
                  filled
                  hide-details
                ></v-autocomplete>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row class="custom-pagination-figma-v3-first mt-3 mb-0">
      <v-col class="page-control-content page-control-bg">
        <v-row class="mt-0">
          <v-col lg="6" md="6">
            <v-row class="mt-0">
              <v-col class="page-control-bg" cols="12">
                <v-btn
                  @click="openAddAdapterWindow(null, 'Add')"
                  :disabled="!$auth.manage"
                  class="btn btn-add"
                  >{{ $t('btn.common.add') }}</v-btn
                >
              </v-col>
            </v-row>
          </v-col>
          <v-col lg="2" md="1"></v-col>
          <v-col lg="4" md="5" class="filter-search">
            <v-row class="mt-0">
              <v-col class="mr-0 pr-0 pl-0" lg="5" md="5">
                <v-select
                  v-model="searchBy"
                  :items="searchByItems"
                  :placeholder="$t('lbl.common.searchTypePlaceHolder')"
                  class="search-by data-table-select-box custom-selectbox pla-col mr-0 flat-file-selectbox"
                  height="40"
                  hide-details
                  dense
                  solo
                ></v-select>
              </v-col>
              <v-col class="ml-0 pl-0" cols="12" md="7">
                <v-text-field
                  v-model="searchByTxt"
                  @input="onFilterDBAdapter"
                  @click:append="onFilterDBAdapter"
                  @keyup.enter="onFilterDBAdapter"
                  :placeholder="$t('lbl.common.searchPlaceHolder')"
                  class="data-table-filter-text-field search-button-data-analysis-table flat-file"
                  heigth="30"
                  append-icon="fa fa-search"
                  hide-details
                  dense
                  solo
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row class="mt-0">
      <system-progress :sysloading="isLoading" :sysloadingTitle="sysloadingTitle"></system-progress>
      <v-col cols="12" class="py-0">
        <v-data-table
          :headers="headers"
          :items="listData"
          :hide-default-footer="true"
          :page.sync="page"
          :items-per-page="itemsPerPage"
          :fixed-header="true"
          :height="tableHeight"
          @click:row="onClickRow"
          @page-count="pageCount = $event"
          group-by="dba_id"
          sort-by="rowid"
          :class="[
            'list-table code-table srm-list-table custom-border-table',
            totalCnt > 0 ? '' : 'custom-border-table-not-data',
          ]"
          no-data-text="No matching records found"
        >
          <template v-slot:item.INDEX="{ item }">
            <div class="index-col">{{ item.rowid }}</div>
          </template>
          <template v-slot:item.dba_name="{ item }">
            <div class="col-name">{{ item.dba_name }}</div>
          </template>
          <template v-slot:item.agent_name="{ item }">
            <div class="col-name">{{ item.agentNm }}</div>
          </template>
          <template v-slot:item.ip_port="{ item }">
            <div class="col-name">{{ item.agentAddress }}:{{ item.agentPort }}</div>
          </template>
          <template v-slot:item.manage="{ item }">
            <div class="text-center">
              <v-btn
                small
                text
                icon
                @click="openAddAdapterWindow(item, 'Edit')"
                :disabled="!$auth.manage"
              >
                <icon-svg :disabled="!$auth.manage" iconName="edit" />
              </v-btn>
              <v-btn small text icon @click="deleteItem(item)" :disabled="!$auth.manage">
                <icon-svg :disabled="!$auth.manage" iconName="delete" />
              </v-btn>
            </div>
          </template>
          <template v-slot:group.header="{ group, items, isOpen, toggle, remove }">
            <td colspan="2" class="pl-0">
              <v-btn icon @click="toggle" class="ml-0">
                <v-icon v-if="isOpen" small>mdi-minus</v-icon>
                <v-icon v-else small>mdi-plus</v-icon>
              </v-btn>
              <span class="ml-1">{{ items[0].dba_id }}</span>
            </td>
            <td colspan="10" class="pl-0"></td>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <v-row v-show="totalCnt > 0" class="custom-pagination-figma-v3-last">
      <v-col class="page-control-content page-control-bg transaction-pagi">
        <v-row class="mt-0">
          <v-col lg="12" md="12">
            <v-row class="mt-0">
              <v-col class="page-control-bg text-left pa-0" cols="6">
                <div class="custom-pagi-selectbox">
                  <v-select
                    v-model="itemsPerPage"
                    hide-details
                    dense
                    solo
                    :items="rowPerPage"
                    class="data-table-select-box custom-selectbox mr-0 page-flat-file-selectbox"
                  ></v-select>
                </div>
              </v-col>
              <v-col class="page-control-bg text-right pa-0" cols="6">
                <div class="page-showing">
                  <v-label
                    >{{ itemsPerPage * (page - 1) + 1 }} ~
                    {{ totalCnt - itemsPerPage * page > 0 ? itemsPerPage * page : totalCnt }}
                    of {{ totalCnt }}</v-label
                  >
                </div>
                <button
                  type="button"
                  @click="handlePageChange(1)"
                  :class="[
                    'custom-btn-first-last-paging',
                    page == 1 ? ' v-pagination__navigation--disabled' : '',
                  ]"
                >
                  <div class="ml-2 pr-2 d-inline">
                    <span>
                      <i class="fa fa-sm fa-step-backward"></i>
                    </span>
                  </div>
                </button>
                <button
                  type="button"
                  @click="changePageByTextbox(-1)"
                  :class="[
                    'mr-3 custom-btn-first-last-paging',
                    page - 1 < 1 ? ' v-pagination__navigation--disabled' : '',
                  ]"
                >
                  <div class="ml-2 pr-2 d-inline">
                    <span>
                      <i class="fa fa-lg fa-caret-left"></i>
                    </span>
                  </div>
                </button>
                <v-text-field
                  v-model="pageEnter"
                  hide-details
                  dense
                  solo
                  class="data-table-filter-text-field custom-pagi-selectbox page-selectbox"
                  @keyup.enter="changePageByTextbox(0)"
                ></v-text-field>
                <label>/ {{ pageCount }}</label>
                <button
                  type="button"
                  @click="changePageByTextbox(1)"
                  :class="[
                    'ml-3 custom-btn-first-last-paging',
                    page + 1 > pageCount ? ' v-pagination__navigation--disabled' : '',
                  ]"
                >
                  <div class="mr-2 pl-2 d-inline">
                    <span>
                      <i class="fa fa-lg fa-caret-right"></i>
                    </span>
                  </div>
                </button>
                <button
                  type="button"
                  @click="handlePageChange(pageCount)"
                  :class="[
                    'custom-btn-first-last-paging',
                    page == pageCount ? ' v-pagination__navigation--disabled' : '',
                  ]"
                >
                  <div class="mr-2 pl-2 d-inline">
                    <span>
                      <i class="fa fa-sm fa-step-forward"></i>
                    </span>
                  </div>
                </button>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <dialogWindow
      ref="confirmDeleteFileDialog"
      size="max"
      :info="deleteDataName"
      title="confirmDialog"
      :detail="$t('msg.dbAdapter.deleteConfirm')"
      color="confirmation"
      :dataValue="deleteData"
      @select-ok="okDeleteFile($event)"
      :showCancel="true"
    ></dialogWindow>
    <dialogWindow
      ref="validateDate"
      size="max"
      :detail="$t('msg.common.validateDate')"
      color="validation"
    ></dialogWindow>
    <div v-for="dialog in dialogs" :key="dialog.id" class="dialogs">
      <versionHistory
        v-if="dialog.type == 'versionHistory'"
        class="custom-dialog mapper-version"
        :closeDialog="removeDialog"
        :dragEnd="dialogDragEnd"
        :dragStart="selectDialog"
        :move="dialogDragEnd"
        :options="dialog.options"
        :id="dialog.id"
        title="DataSource"
      ></versionHistory>
    </div>
  </div>
</template>

<script>
import { getAppliedTimeZone } from '@/vue-dlb/utils/util';
import SystemProgress from '@/vue-dlb/components/SystemProgress.vue';
import { mapGetters, mapState } from 'vuex';
import { resizeTableHeight } from '@/vue-dlb/common/common';
import $ from 'jquery';
import IconSvg from '@/vue-caas/components/IconBase.vue';
import dialogWindow from '@/vue-dlb/components/NewDialog.vue';
import versionHistory from '@/vue-caas/components/DelHistoryWorkflowDialog.vue';
import cfg from '@/vue-caas/config/config.js';
import EventBus from '@/vue-caas/views/process/component/event-bus.js';
import { openWindow } from '@/vue-dlb/utils/window-opener';

export default {
  components: {
    versionHistory,
    SystemProgress,
    IconSvg,
    dialogWindow,
  },
  data() {
    return {
      dialogs: [],
      dialogId: 1,
      arrLayoutDialog: [],
      types: [
        { value: '', text: this.$t('lbl.common.conditionSearch.all') },
        { text: 'DB to JSON', value: 'D2J' },
        { text: 'JSON to DB', value: 'J2D' },
        { text: 'DB to DB', value: 'D2D' },
        { text: 'DB to FlatFile', value: 'D2F' },
      ],
      db_item: {
        name: '',
        type: '',
        company: '',
        agent: '',
        origin: '',
        target: '',
        module: '',
        dbInstance: '',
        dbIFConfig: '',
        controlTable: '',
        dbmapper: '',
      },
      dataType: true,
      fromDate: false,
      fromDateData: getAppliedTimeZone(),
      toDateData: getAppliedTimeZone(),
      toDate: false,
      dateCond: true,
      searchBy: 'all',
      searchByTxt: '',
      listData: [],
      page: 1,
      pageCount: 0,
      itemsPerPage: 50,
      tableHeight: '',
      totalCnt: 0,
      pageEnter: 1,
      isCreated: false,
      isLoading: false,
      deleteData: [],
      deleteDataName: '',
      selectedRow: '',
      deleteItems: {
        agent_id: '',
      },
      editedItem: {
        action: '',
      },
      headers: [
        {
          text: this.$t('tbl.common.columnNo'),
          value: 'INDEX',
          width: '60px',
          align: 'center',
        },
        { text: 'Name', value: 'dba_name', width: '350px', align: 'center' },
        { text: 'Company', value: 'comp_id', align: 'center' },
        { text: 'Agent', value: 'agent_name', width: '100px', align: 'center' },
        { text: 'IP : Port', value: 'ip_port', align: 'center' },
        {
          text: 'Origin - Target',
          value: 'from_to',
          width: '150px',
          align: 'center',
        },
        {
          text: 'Module',
          value: 'config_module',
          width: '150px',
          align: 'center',
        },
        {
          text: 'DB Instance',
          value: 'config_db_instance',
          width: '150px',
          align: 'center',
        },
        {
          text: 'DB I/F Configuration',
          value: 'config_name',
          width: '170px',
          align: 'center',
        },
        {
          text: 'I/F Control Table',
          value: 'config_table',
          width: '150px',
          align: 'center',
        },
        {
          text: 'Type Mapper',
          value: 'mapper_type',
          width: '150px',
          align: 'center',
        },
        {
          text: 'Manage',
          value: 'manage',
          width: '100px',
        },
      ],
      searchByItems: [
        { text: this.$t('lbl.common.searchTypePlaceHolder'), value: 'all' },
        { text: 'Name', value: 'dba_name' },
        { text: 'Company', value: 'comp_id' },
        { text: 'Agent', value: 'agent_name' },
        { text: 'IP', value: 'ip_port' },
        { text: 'Origin', value: 'from_to' },
        { text: 'Target', value: 'from_to' },
        { text: 'DB Instance', value: 'config_db_instance' },
        { text: 'Table', value: 'config_table' },
        { text: 'Xml Mapper', value: 'mapper_name' },
      ],
      rowPerPage: [
        { value: 10, text: 'Show 10' },
        { value: 25, text: 'Show 25' },
        { value: 50, text: 'Show 50' },
        { value: 75, text: 'Show 75' },
        { value: 100, text: 'Show 100' },
      ],
      agentList: [{ value: '', text: this.$t('lbl.common.conditionSearch.all') }],
      dbInstanceList: [{ value: '', text: this.$t('lbl.common.conditionSearch.all') }],
      dbIFControlTableSelectList: [{ value: '', text: this.$t('lbl.common.conditionSearch.all') }],
      dbMapperSelectList: [{ value: '', text: this.$t('lbl.common.conditionSearch.all') }],
      dbIFConfigNameSelectList: [{ value: '', text: this.$t('lbl.common.conditionSearch.all') }],
      companySelectList: [{ value: '', text: this.$t('lbl.common.conditionSearch.all') }],
      w: null,
      preType: null,
    };
  },
  watch: {
    listData() {
      return this.listData;
    },
    page() {
      this.pageEnter = this.page;
    },
  },
  computed: {
    getMaxDate() {
      return getAppliedTimeZone();
    },
    getMinDate() {
      return this.fromDateData;
    },
    ...mapState('common', {
      sysloadingTitle: 'sysloadingTitle',
    }),
    ...mapGetters([
      'dbAdapterList',
      'companyAdapterList',
      'agentAdapterList',
      'agentAdapterListAll',
      'dbAdapterConfigList',
      'interfaceControlTableList',
    ]),
  },
  async created() {
    this.$store.dispatch('getCompanyListSetup').then(() => {
      this.companySelectList = [...this.companyAdapterList];
      this.companySelectList.unshift({
        value: '',
        text: this.$t('lbl.common.conditionSearch.all'),
      });
      this.agentList = [...this.agentAdapterListAll];
      this.agentList.unshift({ value: '', text: this.$t('lbl.common.conditionSearch.all') });
    });
    this.searchItem();
    EventBus.$on('delete-item', this.okDeleteFile);
    this.isCreated = true;
  },
  methods: {
    displaySearchConditions(action) {
      if (action === 'expand') {
        $('.date-query-section').css('display', 'block');
        $('.data-query-section').css('display', 'block');
        $('.expand-search-conditions').css('display', 'none');
        $('.collapse-search-conditions').css('display', 'block');
      } else {
        $('.date-query-section').css('display', 'none');
        $('.data-query-section').css('display', 'none');
        $('.expand-search-conditions').css('display', 'block');
        $('.collapse-search-conditions').css('display', 'none');
      }
    },
    onChangeCompany() {
      this.resetField();
      if (this.db_item.company) {
        this.db_item.agent = '';
        this.agentList = [{ value: '', text: this.$t('lbl.common.conditionSearch.all') }];
        this.$store.dispatch('getAgentAdapterList', { compId: this.db_item.company }).then(() => {
          this.agentList = [...this.agentAdapterList];
          this.agentList.unshift({ value: '', text: this.$t('lbl.common.conditionSearch.all') });
        });
      } else {
        this.db_item.agent = '';
        this.agentList = [{ value: '', text: this.$t('lbl.common.conditionSearch.all') }];
        this.$store.dispatch('getCompanyList').then(() => {
          this.agentList = [...this.agentAdapterListAll];
          this.agentList.unshift({ value: '', text: this.$t('lbl.common.conditionSearch.all') });
        });
      }
      this.searchItem();
    },
    resetField() {
      this.db_item.dbInstance = '';
      this.db_item.dbIFConfig = '';
      this.db_item.controlTable = '';
      this.db_item.dbmapper = '';
      this.dbInstanceList = [{ value: '', text: this.$t('lbl.common.conditionSearch.all') }];
      this.dbIFControlTableSelectList = [
        { value: '', text: this.$t('lbl.common.conditionSearch.all') },
      ];
      this.dbIFConfigNameSelectList = [
        { value: '', text: this.$t('lbl.common.conditionSearch.all') },
      ];
      this.dbMapperSelectList = [{ value: '', text: this.$t('lbl.common.conditionSearch.all') }];
    },
    onChangeAgent() {
      this.resetField();
      if (this.db_item.agent) {
        this.onChangeField();
      } else {
        this.resetField();
      }
      this.searchItem();
    },
    onChangeField() {
      const params = this.changeDtTp();
      this.$store.dispatch('getDBAdapterList', params).then(() => {
        let dbInstance = [];
        let dbIFConfigName = [];
        let dbTable = [];
        let dbMapName = [];
        for (let i = 0; i < this.dbAdapterList.length; i += 1) {
          let temp1 = {
            text: this.dbAdapterList[i].config_db_instance,
            value: this.dbAdapterList[i].config_db_instance,
          };
          let temp2 = {
            text: this.dbAdapterList[i].config_name,
            value: this.dbAdapterList[i].config_name,
          };
          let temp3 = {
            text: this.dbAdapterList[i].config_table,
            value: this.dbAdapterList[i].config_table,
          };
          let temp4 = {
            text: this.dbAdapterList[i].mapper_name,
            value: this.dbAdapterList[i].mapper_name,
          };
          dbInstance.push(temp1);
          dbIFConfigName.push(temp2);
          dbTable.push(temp3);
          dbMapName.push(temp4);
        }
        this.dbInstanceList = [...new Set(dbInstance)];
        this.dbInstanceList.unshift({ value: '', text: this.$t('lbl.common.conditionSearch.all') });
        this.dbIFConfigNameSelectList = [...new Set(dbIFConfigName)];
        this.dbIFConfigNameSelectList.unshift({
          value: '',
          text: this.$t('lbl.common.conditionSearch.all'),
        });
        this.dbIFControlTableSelectList = [...new Set(dbTable)];
        this.dbIFControlTableSelectList.unshift({
          value: '',
          text: this.$t('lbl.common.conditionSearch.all'),
        });
        this.dbMapperSelectList = [...new Set(dbMapName)];
        this.dbMapperSelectList.unshift({
          value: '',
          text: this.$t('lbl.common.conditionSearch.all'),
        });
      });
      this.searchItem();
    },
    validateDateInput(dateString) {
      var regEx = /^\d{4}-\d{2}-\d{2}$/;
      if (!dateString.match(regEx)) return false;
      var d = new Date(dateString);
      var dNum = d.getTime();
      if (!dNum && dNum !== 0) return false;
      return d.toISOString().slice(0, 10) === dateString;
    },
    formatDate(side, evt) {
      let dateString = side === 'from' ? this.fromDateData : this.toDateData;
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46 && charCode !== 45) {
        evt.preventDefault();
      } else if (
        (charCode !== 46 &&
          charCode !== 8 &&
          charCode !== 45 &&
          dateString.length === 4 &&
          !dateString.includes('-')) ||
        (charCode !== 46 &&
          charCode !== 8 &&
          charCode !== 45 &&
          dateString.length === 7 &&
          dateString[4] === '-' &&
          (dateString.match(/-/g) || []).length == 1)
      ) {
        dateString += '-';
        side === 'from' ? (this.fromDateData = dateString) : (this.toDateData = dateString);
      } else {
        return true;
      }
    },
    changeDate(side) {
      if (side === 'from') {
        if (!this.validateDateInput(this.fromDateData)) {
          this.$refs.validateDate.dialog = true;
          this.fromDateData = getAppliedTimeZone();
          this.toDateData = getAppliedTimeZone();
          return;
        }
        if (this.fromDateData > getAppliedTimeZone()) {
          this.fromDateData = getAppliedTimeZone();
        }
        if (this.fromDateData > this.toDateData) {
          this.toDateData = this.fromDateData;
        }
      }
      if (side === 'to') {
        if (!this.validateDateInput(this.toDateData)) {
          this.$refs.validateDate.dialog = true;
          this.toDateData = getAppliedTimeZone();
          this.fromDateData = getAppliedTimeZone();
          return;
        }
        if (this.toDateData > getAppliedTimeZone()) {
          this.toDateData = getAppliedTimeZone();
        }
        if (this.fromDateData > this.toDateData) {
          this.fromDateData = this.toDateData;
        }
      }
    },
    changeDtTp() {
      const params = {
        dba_name: this.db_item.name,
        dba_type: this.db_item.type,
        company: this.db_item.company,
        agent_id: this.db_item.agent,
        config_from: this.db_item.origin,
        config_to: this.db_item.target,
        module: this.db_item.module,
        db_instance: this.db_item.dbInstance,
        config_name: this.db_item.dbIFConfig,
        config_table: this.db_item.controlTable,
        mapper_name: this.db_item.dbmapper,
      };
      if (this.dataType) {
        params.fr_date = this.fromDateData;
        params.to_date = this.toDateData;
        this.fromDateData = this.fromDateData || getAppliedTimeZone();
        this.toDateData = this.toDateData || getAppliedTimeZone();
        this.dateCond = true;
      } else {
        this.fromDateData = '';
        this.toDateData = '';
        this.dateCond = false;
      }
      return params;
    },
    async searchItem() {
      this.isLoading = true;
      const params = this.changeDtTp();
      let result = [];
      await this.$store
        .dispatch('getDBAdapterList', params)
        .then(async () => {
          result = this.$store.getters.dbAdapterList;

          await this.$store.dispatch('getAgentListAll').then(() => {
            let listAgent = this.$store.getters.agents;
            result.map(async (temp) => {
              const index = listAgent.findIndex((e) => e.agentId == temp.agent_id);
              if (index > -1) {
                temp.agentAddress = listAgent[index].agentAddress;
                temp.agentNm = listAgent[index].agentNm;
                temp.agentPort = listAgent[index].agentPort;
              }
            });
          });
        })
        .catch((ex) => {
          this.isLoading = false;
        });

      this.isLoading = false;
      this.totalCnt = result.length;
      this.caculatePageCount();
      this.listData = result;
    },
    caculatePageCount() {
      if (this.totalCnt % this.itemsPerPage === 0) {
        this.pageCount = this.totalCnt / this.itemsPerPage;
      } else {
        this.pageCount = Math.floor(this.totalCnt / this.itemsPerPage) + 1;
      }
    },
    deleteItem(item) {
      this.deleteData = item;
      this.deleteDataName = item.dba_name;
      let self = this;
      if (cfg.isDlb) {
        self.$refs.confirmDeleteFileDialog.dialog = true;
      } else {
        this.$store
          .dispatch('getListUseInWorkflow', { type: 'DBA', value: item.dba_id })
          .then((res) => {
            if (res.length > 0) {
              self.openVersionHistory(res, item);
            } else {
              self.$refs.confirmDeleteFileDialog.dialog = true;
            }
          });
      }
    },
    okDeleteFile(item) {
      this.deleteItems = {
        dba_id: item.dba_id,
        dba_child_id: item.dba_child_id,
        dba_type: item.dba_type,
        sql_grp_id: item.sql_grp_id,
        dba_mapper_id: item.dba_mapper_id,
      };
      this.$store.dispatch('deleteDBAdapter', this.deleteItems).then((res) => {
        this.searchItem();
      });
    },
    onFilterDBAdapter(str) {
      setTimeout(() => {
        this.$store
          .dispatch('setFilterDBAdapter', {
            searchBy: this.searchBy,
            str: this.searchByTxt,
          })
          .then(() => {
            this.listData = this.$store.getters.dbAdapterList;
            this.totalCnt = this.listData.length;
            this.caculatePageCount();
          });
      }, 300);
    },
    changePageByTextbox(value) {
      let data = parseInt(this.pageEnter);
      if (isNaN(data)) {
        this.pageEnter = this.page;
        return;
      } else {
        this.page = data > this.pageCount ? this.pageCount : data < 1 ? 1 : data;
        this.pageEnter = this.page;
      }
      this.page += value;
    },
    handlePageChange(value) {
      this.page = value;
    },
    openAddAdapterWindow(item, type) {
      let isEdit = false;
      let params = {};
      if (type === 'Edit') {
        this.editedItem = Object.assign({}, item);
        this.editedItem.action = 'Edit';
        this.editedItem.formtitle = 'Modify DB Adapter';
        isEdit = true;
        params = {
          ROWID: item.dba_child_id.toString(),
          editedItem: Object.assign({}, this.editedItem),
          options: {
            id: item.dba_child_id.toString(),
            isEdit: isEdit,
            company: this.companyAdapterList,
          },
        };
      } else {
        item = { dba_child_id: '0' };
        this.editedItem = {};
        this.editedItem.action = 'Add';
        this.editedItem.formtitle = 'Add DB Adapter';
        params = {
          ROWID: '0',
          editedItem: Object.assign({}, this.editedItem),
          options: {
            id: '0',
            isEdit: isEdit,
            company: this.companyAdapterList,
          },
        };
      }
      item.id = item.dba_child_id.toString();
      const arrView = {
        item,
        type,
      };
      const url = `/component/dbadapter/dbadapterbuilder/${type}/${params.options.id}`;
      this.preType = type;
      openWindow({
        arrView,
        url: url,
        params,
        onClose: () => {
          this.searchItem();
        },
      });
    },
    openVersionHistory(list, val) {
      let type = 'versionHistory';
      let item = {};
      item.ROWID = 0;
      item.versionList = list;
      item.comNm = val.name;
      item.item = this.deleteData;
      let indexArrDialog = this.findDialog('versionHistory_0');
      if (indexArrDialog != null) {
        this.dialogs[indexArrDialog].options.item = item;
        return;
      }
      this.newDialog(item, type) - 1;
    },
    findDialog(id, dialogs) {
      if (!dialogs) dialogs = this.dialogs;
      let index = dialogs.findIndex((val) => {
        return val.id === id;
      });
      return index > -1 ? index : null;
    },
    newDialog(item, type) {
      return this.dialogs.push(this.generateDialog(item, type));
    },
    generateDialog(item, type) {
      let id = `${type}_${item.ROWID}`;
      this.arrLayoutDialog.push({ id: id });
      this.dialogId++;
      let name = 'Dialog ' + id;
      let options = { left: 30 * this.dialogId, top: 30 * this.dialogId, item };
      return { id, name, type, options };
    },
    removeDialog(dialog) {
      let id = dialog.id;
      let index = this.findDialog(id);
      let indexArrDialog = this.findDialog(id, this.arrLayoutDialog);
      this.arrLayoutDialog.splice(indexArrDialog, 1);
      this.dialogs.splice(index, 1);
      if (this.selected && this.selected.id === id) this.selected = null;
    },
    dialogDragEnd(obj) {
      let index = this.findDialog(obj.id);
      this.$set(this.dialogs[index].options, 'left', obj.left);
      this.$set(this.dialogs[index].options, 'top', obj.top);
    },
    selectDialog(obj) {
      let index = this.findDialog(obj.id);
      this.selected = this.dialogs[index];
    },
    allowedDates(val) {
      let date = getAppliedTimeZone();
      if (val <= date) {
        return val;
      }
    },
    onClickRow(item) {
      this.selectedRow = item.ds_id;
    },
  },
  updated: function() {
    let self = this;
    let arrClassMinus = ['.page-control-content'];
    let arrClassPlus = [];

    if (this.isCreated) {
      let h1 = resizeTableHeight(arrClassMinus, arrClassPlus, true);
      self.tableHeight = h1 - 80 + 'px';
      this.isCreated = false;
    }

    $(window).resize(function(event) {
      let h1 = resizeTableHeight(arrClassMinus, arrClassPlus, true);
      self.tableHeight = h1 - 80 + 'px';
    });
  },
  mounted() {
    window.addEventListener('storage', (event) => {
      if (event.key === 'processSharedData') {
        const updatedState = JSON.parse(event.newValue);
        if (updatedState?.DBA) {
          this.searchItem();
        }
      }
    });
  },
};
</script>

<style>
.maplist-layout-dialog.add-code-dialog {
  width: 1160px !important;
  height: auto !important;
}
</style>
